if (typeof lawyer_directory !== 'object') {
	var lawyer_directory = {};
}

(function ($) {
	let scrollDistance = 0;

	/* use/init Chosen library for the Historical form */
	if( $('.historical-form').length) {
		function chosenSelectInit() {
			$('.historical-form select').chosen({
				allow_single_deselect: true,
				width: '344px'
			});
		}

		setTimeout( () => {
			chosenSelectInit()
		}, 1000)
	}

	let staffHelpers = {
		body: $("body"),

		empty: function (arr) {
			return !((Array.isArray(arr) && arr.length > 0) || (typeof arr === "string" && arr !== ""));
		},
	};

	let staffModal = {
		init: function () {
			this.modal = $(".staff-modal");
			this.modalContent = this.modal.find(".modal-content");
			this.closeBtn = this.modal.find(".close-modal");
			this.memberPhoto = this.modal.find(".staff-modal__avatar img");
			this.memberName = this.modal.find(".staff-modal__name");
			this.memberPosition = this.modal.find(".staff-modal__position");
			this.memberPhone = this.modal.find(".staff-modal__phone");
			this.memberLinkedIn = this.modal.find(".staff-modal__linkedIn");
			this.memberWebsite = this.modal.find(".staff-modal__website");
			this.memberEmail = this.modal.find(".staff-modal__email");
			this.memberHome = this.modal.find(".staff-modal__home");
			this.memberHomeText = this.modal.find(".staff-modal__home-text");
			this.memberStates = this.modal.find(".staff-modal__states");
			this.memberStatesText = this.modal.find(".staff-modal__state-text");
			this.memberBio = this.modal.find(".staff-modal__bio");
			this.memberBioText = this.modal.find(".staff-modal__bio-text");
		},

		fillModalWithData: function (dataArray, key) {
			function checkIfDataFieldEmpty(dataItemParam, blockForInsert) {
				!staffHelpers.empty(dataItemParam) ?
						blockForInsert.show().html(dataItemParam) :
						blockForInsert.hide();
			}

			let renderStatesList = function (states_list) {
				let output = "";
				let counter = 0;

				output += states_list.reduce(function (output, stateName) {
					counter++;

					if( counter < states_list.length) {
						return output +
							`<span class="staff-modal__state" data-state="${stateName}"> 
								${stateName} 
							</span>
							<span class="comma">, </span>`;
					} else {
						return output +
							`<span class="staff-modal__state" data-state="${stateName}"> 
								${stateName} 
							</span>`;
					}
				}, '');
				staffModal.memberStatesText.html(output);
			};

			!staffHelpers.empty(dataArray[key].photo) ?
					staffModal.memberPhoto.attr("src", dataArray[key].photo) :
					staffModal.memberPhoto.hide();

			!staffHelpers.empty(dataArray[key].linkedin) ?
					staffModal.memberLinkedIn.attr("href", dataArray[key].linkedin) &&
					staffModal.memberLinkedIn.show() :
					staffModal.memberLinkedIn.hide();

			!staffHelpers.empty(dataArray[key].website) ?
				staffModal.memberWebsite.attr("href", dataArray[key].website) &&
				staffModal.memberWebsite.show() :
				staffModal.memberWebsite.hide();

			!staffHelpers.empty(dataArray[key].email) ?
				staffModal.memberEmail.attr("href", "mailto:" + dataArray[key].email) &&
				staffModal.memberEmail.show().html(dataArray[key].email) :
				staffModal.memberEmail.hide();

			!staffHelpers.empty(dataArray[key].home_address) ?
				staffModal.memberHomeText.text(dataArray[key].home_address).css({'white-space': 'break-spaces'})
				&& staffModal.memberHome.show() :
				staffModal.memberHome.hide();

			!staffHelpers.empty(dataArray[key].states) ?
				renderStatesList(dataArray[key].states.map( (state) => {
					return state.state;
				})) && staffModal.memberStates.show() :
				staffModal.memberStates.hide();

			!staffHelpers.empty(dataArray[key].bio) ?
				staffModal.memberBioText.text(dataArray[key].bio).css({'white-space': 'break-spaces'})
				&& staffModal.memberBio.show() :
				staffModal.memberBio.hide();

			checkIfDataFieldEmpty(dataArray[key].name, staffModal.memberName);
			checkIfDataFieldEmpty(dataArray[key].position, staffModal.memberPosition);
			checkIfDataFieldEmpty(dataArray[key].phone, staffModal.memberPhone);
		},

		openModal: function () {
			staffModal.modal.addClass("active");

			/* make body "no scroll" when the modal is open */
			scrollDistance = $(window).scrollTop();
			$("body").addClass("no-scroll").css("top", scrollDistance * -1);
		},

		closeModal: function () {
			staffModal.modal.removeClass("active");

			$("body").removeClass("no-scroll").css("top", "");
			$(window).scrollTop(scrollDistance);
		},

		events: function () {
			/* close modal on close Button click */
			staffModal.closeBtn.on("click", staffModal.closeModal);

			/* close modal on click outside*/
			$(document).on("click", function (e) {
				if (staffModal.modal.hasClass("active") && $(e.target).find(staffModal.modalContent).length !== 0) {
					$(e.target).closest(staffModal.modal).removeClass("active");
					$("body").removeClass("no-scroll").css("top", "");
					$(window).scrollTop(scrollDistance);
				}
			});

			/* close modal on ESC click */
			$(document).on("keydown", function (e) {
				if (staffModal.modal.hasClass("active") && e.keyCode === 27) {
					staffModal.modal.removeClass("active");
					$("body").removeClass("no-scroll").css("top", "");
					$(window).scrollTop(scrollDistance);
				}
			});
		}
	};

	if( window.workersList && $(".departments-worker") ) {
        staffModal.init();

        let workersListJson = window.workersList;

        $(".departments-worker").each(function () {
            $(this).on("click", function () {
                staffModal.fillModalWithData(workersListJson, $(this).data('worker-id'));
                staffModal.openModal();
                staffModal.events();
            });
        });
    }

	/* Page Rendering */
	if($('body').is('.page-template-all-md')) {
		let lawyersListJson = lawyer_directory.data;
		let stateSelect = $('#state-select');
		let showAllLayersBtn = `<button id="showAllLayers" 
									class="show-all-layers" 
									type="button" 
									title="ALL MD Lawyer Directory by state"
								>
									<span class="show-all-layers__text">ALL MD Lawyer Directory by state</span>
									<span class="show-all-layers__icon">&raquo;</span>
								</button>`;

		// stateSelect.chosen({ width:'200px' })

		let triggerLawyerModal = function() {
			$(".departments-worker").each(function () {
				$(this).on("click", function () {
					let dataId = $(this).attr('data-worker-id');

					staffModal.fillModalWithData(lawyersListJson, dataId);
					staffModal.openModal();
					staffModal.events();

					$('.staff-modal__state').on('click', function() {
						currentState = $(this).attr('data-state');

						let currentStateArr = [currentState];

						staffModal.closeModal();

						lawyer_directory.render(currentStateArr);

						stateSelect.val(currentState);
						stateSelect.trigger("chosen:updated");

					})
				});
			});
		}

		staffModal.init();

		triggerLawyerModal();

		lawyer_directory.render = function (states_list) {
			let output = "";
			output += states_list.reduce(function (output, stateName) {
				return output +
					'<div class="departments-single">' +
					'<h3 class="h3">' + stateName + '</h3>' +
					'<div class="departments-workers">' +
					lawyer_directory.getLayersByState(stateName) +
					'</div>' +
					'</div>';
			}, '');

			/* insert the rendered states list (with layers) into the DOM */
			$('.states-list').html(output);

			/* show only the first rendered state (with layers) */
			lawyer_directory.displayLayers();

			/* show all the remaining states (with layers) and hide the button */
			$('#showAllLayers').on('click', function () {
				lawyer_directory.showAllLayers();
				$(this).hide();
			});

			triggerLawyerModal();
		};

		lawyer_directory.displayLayers = function () {
			let stateListItems = document.querySelectorAll('.states-list .departments-single');

			stateListItems.forEach(function (item, index) {
				index !== 0 ? item.classList.add('hidden') : ''
			})

			$('.states-list').append(showAllLayersBtn);
		}

		lawyer_directory.showAllLayers = function () {
			let stateListItems = document.querySelectorAll('.states-list .departments-single');

			stateListItems.forEach(function (item) {
				item.classList.remove('hidden')
			})
		}

		lawyer_directory.getLayer = function (id) {
			let lawyer = lawyer_directory.data[id];
			return '<div class="departments-worker" data-worker-id="' + id + '" tabindex="0" role="button">' +
				'<div class="departments-worker__link open-modal">' +
				'<div class="departments-worker__img">' + '<img src="' + lawyer.photo + '" alt="">' + '</div>' +
				'<span class="h3 departments-worker__name">' + lawyer.name + '</span>' +
				'<div class="departments-worker__position">' + lawyer.position + '</div>' +
				'</div>' +
				'</div>';
		};

		lawyer_directory.getLayersByState = function (state) {
			let output = '';
			lawyer_directory.data.forEach(function (el, i) {
				if (el.states.some((el) => el.state === state)) {
					output += lawyer_directory.getLayer(i);
				}
			});
			return output;
		};

		lawyer_directory.render(lawyer_directory.used_states);

		stateSelect.on('change', function (event) {
			if (event.target.value === 'all') {
				lawyer_directory.render(lawyer_directory.used_states);

			} else {
				lawyer_directory.render([event.target.value]);
				$('.show-all-layers').hide(); // hide "Show All Layers button"
			}
		});
	}
})(jQuery);
